<template lang="pug">
  .chat-dialog__main(v-loading="isLoading")
    .chat-unload__mask(v-if="!messageMember")
    .chats__title(v-if="messageMember")
      span Диалог с пользователем
      span.member__title(:class="memberInBlacklist ? 'color-danger' : 'color-success'") {{ messageMember }}
      i.el-icon-warning.user-blacklist__icon.color-danger(
        v-if="memberInBlacklist"
        :title="memberBlacklistNote || 'ПОЛЬЗОВАТЕЛЬ ИЗ ЧЁРНОГО СПИСКА'"
        @click="startDeleteBlacklistUser()"
        )
      i.el-icon-success.user-blacklist__icon.color-success(
        v-else title="Добавить в ЧС"
        @click="activateAddBlacklistUser()"
        )
      .member-stats__container(v-if="memberStats")
        span (
        span.success {{ memberStats.success }}
        span |
        span.canceled {{ memberStats.canceled }}
        span )
      el-button.leave__btn(
        v-if="isOpened && role === 'superadmin'"
        @click="openCloseTicket()"
        type="danger"
        size="mini"
        :disabled="isTicketClosing"
        ) Закрыть
    .chat-dialog-messages__container
      i.el-icon-more.chat-dialog-messages__load(
        v-if="messageMember && !getActiveChatIsFullyLoaded"
        @click="loadMoreMessages()"
        v-loading="loadMoreLoading"
        :class="{ isLoading: loadMoreLoading }"
        )
      .chat-dialog-message__container(
        v-for="message in getActiveChat.messages"
        :class="{ own: message.username === exchangeName }"
        )
        .dialog-message__text {{ message.text }}
        .dialog-message__details
          .dialog-message__info
            span {{ message.username }}
            span.dialog-message__sender(
              v-if="message.sender"
              :class="message.sender === 'system' ? 'system' : 'user'"
              ) {{ ` (${message.sender})` }}
          .dialog-message__info {{ message.ts }}
    .chat-dialog-answer__container
      el-input.dialog__input(v-model="message" type="textarea" :autosize="{ minRows: 2, maxRows: 4}")
      .chat-dialog-additional__container
        .chat-dialog-templates__contaner(v-if="role !== 'partner-admin'" title="Шаблоны")
          i.el-icon-document.chat-dialog-additional__button(@click="showTemplates = true")
        .chat-dialog-upload__contaner(title="Загрузить изображение")
          i.el-icon-upload.chat-dialog-additional__button(@click="uploadFile()")
      el-button(@click="sendMessage()" type="primary") Отправить
    el-dialog(
    title="Шаблоны ответов"
    :visible.sync="showTemplates"
    custom-class="templates__dialog"
    width="60%",
    height="80%",
    )
      .templates-dialog__container
        .templates-dialog__list
          .template-add__container
            el-button(type="success" @click="addNewTemplate()") Добавить
          .templates-dialog__template(v-for="(template, index) in templates" :key="`template-${index}`")
            .template__container(v-if="isTemplateEdit && editedTemplateIndex === index")
              el-input(v-model="editedTemplate" type="textarea" :autosize="{ minRows: 4, maxRows: 8}")
              .template-dialog__buttons
                el-button.template__button(type="success" @click="saveTemplate(index)") Сохранить
                el-button.template__button(type="danger" @click="disableTemplateEdit()") Отменить
            .template__container(v-else)
              .template-dialog__text {{ template.text }}
              .template-dialog__buttons(v-if="!isNewTemplateAdding")
                el-button.template__button(type="success" @click="useTemplate(index)") Выбрать
                el-button.template__button(type="primary" @click="enableTemplateEdit(index)") Изменить
                el-button.template__button(type="danger" @click="deleteTemplate(index)") Удалить
    el-dialog(
      :visible.sync="isBlackListAdding"
      :before-close="resetBlacklistUserAdding"
      title="Добавление пользователя"
      width="30%"
    )
      .h3 Введите данные
      .exchange-finish__container
        .exchange-finish__input
          el-input(v-model="messageMember" :disabled="true" placeholder="Имя пользователя")
        .exchange-finish__input
          el-input(v-model="blackListNote" placeholder="Примечание")
        .exchange-finish__buttons
          el-button(type="success" @click="startAddBlacklistUser()") Добавить
          el-button(type="danger" @click="resetBlacklistUserAdding()") Отменить
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import {
    ADD_TEMPLATE,
    CHAT_SEND_MESSAGE, CLOSE_TICKET,
    DELETE_TEMPLATE,
    EDIT_TEMPLATE, HANDLE_BLACKLIST_USER,
    LOAD_CHAT
  } from "../../store/const/chats";
  import { ADD_BLACK_LIST_USER, DELETE_BLACK_LIST_USER } from "../../store/const/exchange";
  export default {
    name: 'ChatsDialog',
    props: {
      resetMessage: {
        type: Boolean,
        default: false,
      },
      scrollToEnd: {
        type: Boolean,
        default: false,
      },
      showChatLoadingStatus: {
        type: Boolean,
        default: false,
      },
      loadMoreLoading: {
        type: Boolean,
        default: false,
      },
      isOpened: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        message: '',
        showTemplates: false,
        templates: [],
        isTemplateEdit: false,
        editedTemplate: '',
        editedTemplateIndex: 0,
        isNewTemplateAdding: false,
        isTicketClosing: false,
        isBlackListAdding: false,
        blackListNote: '',
      }
    },
    mounted() {
      this.templates = this.getTemplates;
      this.scrollToEndOfDialog();
    },
    watch: {
      resetMessage() {
        this.message = '';
      },
      scrollToEnd() {
        this.scrollToEndOfDialog();
      },
      getTemplates(templates) {
        this.templates = templates;
      },
      lastLoadedMessageId(val) {
        this.scrollToEndOfDialog();
      },
    },
    computed: {
      ...mapGetters('chats', {
        getActiveChat: 'activeChat',
        getActiveChatId: 'activeChatId',
        getActiveChatIsFullyLoaded: 'activeChatIsFullyLoaded',
        getTemplates: 'templates',
        lastLoadedMessageId: 'lastMessageId',
        chatsList: 'chatsList',
      }),
      ...mapGetters('settings', {
        exchangeName: 'exchangeName',
      }),
      ...mapGetters('user', {
        role: 'getRole',
      }),
      ...mapGetters([
        'loading',
      ]),
      isLoading() {
        return this.loading(LOAD_CHAT) === 'loading' && this.showChatLoadingStatus;
      },
      messageMember() {
        return this.getActiveChat.member;
      },
      memberStats() {
        return Object.keys(this.getActiveChat.stats).length > 0 ? this.getActiveChat.stats : null;
      },
      memberInBlacklist() {
        return this.getActiveChat.client_in_blacklist;
      },
      memberBlacklistNote() {
        return this.getActiveChat.blacklist_note;
      },
      messages() {
        return this.getActiveChat.messages;
      },
    },
    methods: {
      ...mapActions('chats', {
        loadChat: LOAD_CHAT,
        sendToChat: CHAT_SEND_MESSAGE,
        addTemplate: ADD_TEMPLATE,
        editTemplateById: EDIT_TEMPLATE,
        deleteTemplateById: DELETE_TEMPLATE,
        closeTicket: CLOSE_TICKET,
        handleBlacklistUser: HANDLE_BLACKLIST_USER,
      }),
      ...mapActions('exchange', {
        addBlacklistUser: ADD_BLACK_LIST_USER,
        deleteBlacklistUser: DELETE_BLACK_LIST_USER,
      }),
      async loadMoreMessages() {
        if (!this.loadMoreLoading) {
          await this.$emit('updateChat', { id: 'current', loadMore: true });
        }
      },
      async sendMessage() {
        const message = this.message.replace(/\n/gm, '\n\r');
        const result = await this.sendToChat({ id: this.getActiveChatId, message });
        if (result.success) {
          this.message = '';
          setTimeout(async () => {
            await this.$emit('updateChat', { id: 'current' });
          }, 500);
          this.scrollToEndOfDialog();
        } else {
          this.$message({
            type: 'error',
            message: `Ошибка отправки: ${result.message || 'неизвестная ошибка'}`,
          })
        }
      },
      openCloseTicket() {
        this.$confirm('Вы уверены, что хотите закрыть обращение?', 'Подтверждение').then(async () => {
          this.isTicketClosing = true;
          const request = await this.closeTicket(this.getActiveChatId);
          this.isTicketClosing = false;
          if (request.success) {
            this.$message.success('Обращение успешно закрыто');
          } else {
            this.$message.error(request.message || 'Неизвестная ошибка');
          }
        }).catch(() => {
          this.$message.info('Отменено');
        });
      },
      scrollToEndOfDialog() {
        if (this.isLoading || !this.$el.querySelector) {
          setTimeout(() => {
            this.scrollToEndOfDialog();
          }, 200);
        } else {
          setTimeout(() => {
            const container = this.$el.querySelector(".chat-dialog-messages__container");
            container.scrollTop = container.scrollHeight + 500;
          }, 300);
        }
      },
      enableTemplateEdit(index) {
        this.editedTemplateIndex = index;
        this.editedTemplate = this.templates[index].text;
        this.isTemplateEdit = true;
      },
      disableTemplateEdit() {
        if (this.isNewTemplateAdding) {
          this.templates = this.templates.slice(1);
        }
        this.editedTemplateIndex = null;
        this.editedTemplate = '';
        this.isTemplateEdit = false;
        this.isNewTemplateAdding = false;
      },
      async saveTemplate(index) {
        const template = this.templates[index];
        let result;
        if (template.id) {
          result = await this.editTemplateById({ id: template.id, text: this.editedTemplate });
        } else {
          result = await this.addTemplate(this.editedTemplate);
        }
        if (result.success) {
          this.$message({
            message: `${template.id ? 'Изменение' : 'Добавление'} шаблона успешно`,
            type: 'success',
          });
        } else {
          this.$message({
            message: `Ошибка ${template.id ? 'изменения' : 'добавления'} шаблона`,
            type: 'error',
          });
        }
        this.isNewTemplateAdding = false;
        this.disableTemplateEdit();
      },
      addNewTemplate() {
        this.isNewTemplateAdding = true;
        this.templates = [{ text: '' }, ...this.templates];
        this.enableTemplateEdit(0);
      },
      useTemplate(index) {
        this.message = this.templates[index].text;
        this.showTemplates = false;
      },
      async deleteTemplate(index) {
        const template = this.templates[index];
        let result;
        if (template.id) {
          result = await this.deleteTemplateById(template.id);
        } else {
          result = { success: false };
        }
        if (result.success) {
          this.$message({
            message: `Удаление шаблона успешно`,
            type: 'success',
          });
        } else {
          this.$message({
            message: `Ошибка удаления шаблона`,
            type: 'error',
          });
        }
      },
      convertToHtmlText(text) {
        if (text) {
          return text.replace(/\n/gm, '<br>');
        }
      },
      uploadFile() {
        this.$message('Выгрузка файлов находится в разработке');
      },
      async activateAddBlacklistUser() {
        this.isBlackListAdding = true;
      },
      async startAddBlacklistUser() {
        this.$confirm(`Вы уверены, что хотите добавить пользователя ${this.messageMember} в черный список?`, 'Подтверждение').then(async () => {
          const request = await this.addBlacklistUser({ user: this.messageMember, note: this.blackListNote });
          if (request.success) {
            this.$message.success('Пользователь успешно добавлен в черный список');
            this.handleBlacklistUser({ note: this.blackListNote });
            this.resetBlacklistUserAdding();
          } else {
            this.$message.error(`Ошибка: ${request.message || 'Неизвестная ошибка'}`);
          }
        }).catch((e) => {
          this.$message.info('Добавление отменено');
        });
      },
      async startDeleteBlacklistUser() {
        this.$confirm(`Вы уверены, что хотите удалить пользователя ${this.messageMember} из черного списка?`, 'Подтверждение').then(async () => {
          const request = await this.deleteBlacklistUser(this.messageMember);
          if (request.success) {
            this.$message.success('Пользователь успешно удален из черного списка');
            this.handleBlacklistUser();
          } else {
            this.$message.error(`Ошибка: ${request.message || 'Неизвестная ошибка'}`);
          }
        }).catch(() => {
          this.$message.info('Удаление отменено');
        });
      },
      resetBlacklistUserAdding() {
        this.blackListNote = '';
        this.isBlackListAdding = false;
      },
    }
  }
</script>
<style scoped>
  .chat-dialog__main {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
  }

  .chat-dialog-messages__container {
    padding: 10px;
    background-color: #e4e4e4;
    flex: 1;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
  }

  .chat-dialog-messages__load {
    text-align: center;
    font-size: 20px;
    padding: 5px;
    border: 1px solid #a2a2a2;
    background-color: #f7f6f6;
    width: 50px;
    border-radius: 15px;
    margin: 0 auto 12px;
    cursor: pointer;
  }

  .chat-dialog-messages__load.isLoading {
    cursor: not-allowed;
  }

  .chat-dialog-message__container {
    position: relative;
    padding: 12px 15px;
    border-radius: 5px;
    max-width: 370px;
    background-color: #f1f5fa;
    word-break: break-word;
    margin-bottom: 10px;
  }

  .chat-dialog-message__container.own {
    background-color: #dcf0ff;
    align-self: flex-end;
  }

  .chat-dialog-answer__container {
    display: flex;
    padding: 5px;
    border: 1px solid #e4e4e4;
  }

  .dialog-message__details {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    margin-top: 10px;
    color: gray;
  }

  .dialog-message__sender.user {
    color: #054e9c;
  }

  .dialog-message__sender.system {
    color: #059c11;
  }

  .dialog-message__sender.moderator {
    color: #c33d3d;
  }

  .dialog-message__sender {
    margin-left: 2px;
  }

  .dialog__input {
    margin-right: 10px;
  }

  .chat-dialog-additional__container {
    width: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .chat-dialog-additional__button {
    cursor: pointer;
  }

  .templates-dialog__container {
    height: 600px;
  }

  .templates-dialog__list {
    height: 100%;
    overflow-y: scroll;
  }

  .template-add__container {
    margin-bottom: 10px;
  }

  .templates-dialog__template {
    margin-bottom: 10px;
  }

  .template__container {
    display: flex;
    padding: 8px;
    background-color: #eaeaea;
    border: 1px solid #b3b3b3;
    box-shadow: 1px 1px 1px #d0d0d0;
    align-items: center;
  }

  .template-dialog__text {
    max-height: 150px;
    overflow-y: scroll;
    flex: 1;
  }

  .template-dialog__buttons {
    width: 120px;
    padding: 10px;
  }

  .template-dialog__buttons .template__button {
    width: 100%;
    margin: 5px auto !important;
  }

  .leave__btn {
    margin-left: 10px !important;
  }

  .member-stats__container {
    display: inline-block;
    margin-left: 5px;
  }

  .member-stats__container .success {
    color: #22ff22;
    margin-right: 5px;
    margin-left: 2px;
  }

  .member-stats__container .canceled {
    color: #f56c6c;
    margin-left: 5px;
    margin-right: 2px;
  }

  .chat-unload__mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #afafaf7d;
    z-index: 99999;
    cursor: not-allowed;
  }

  .member__title {
    margin-left: 5px;
  }

  .user-blacklist__icon {
    margin-left: 5px;
    font-weight: bold;
    cursor: pointer;
  }
</style>
